import React from "react";
import { useParams } from "react-router";
import { Loader, Popup } from "uikit/components";
import { BackLink } from "components";
import { useRegionLoading } from "hooks/loading";
import RegionLoadingView from "components/loading/RegionLoadingView/RegionLoadingView";
import { useContextPerson } from "hooks/persons";
import { Flags } from "utils";

export default function RegionLoadingPage() {
    const { regionId } = useParams();
    const { flags, isLoading: isContextLoading } = useContextPerson();
    const { isLoading, data } = useRegionLoading(regionId);

    if (isLoading || isContextLoading) {
        return (
            <Popup blockClickOnOverlay appearance="adaptive">
                <Loader position={"margin-auto"} text={"Подождите. Данные загружаются."} testName="loader-text" />
            </Popup>
        );
    }

    if (data) {
        return (
            <>
                {!flags?.[Flags.HideDashboardBackButton] && (
                    <BackLink
                        to={`/region-summary/${regionId}`}
                        text={"Назад"}
                        name={"region_loading_back_link"}
                    />
                )}
                <RegionLoadingView regionId={Number(regionId)} data={data} />
            </>
        );
    }
}
